module.exports = __webpack_public_path__ + "img/2..49a1150b.jpg";